import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _ from "lodash";
import { SDropdownV3, SField, SInputV2 } from "../..";
export const InputPropertyEditor = ({ value, onChangeValue, readOnly, onClickValue })=>{
    const keyboardTypeOptions = [
        "text",
        "email",
        "number",
        "tel",
        "url",
        "password"
    ].map((type)=>({
            label: _.startCase(type),
            value: type
        }));
    const setProps = (newProps)=>{
        let props = {
            type: "property-input",
            placeholder: "",
            keyboardType: "text"
        };
        onChangeValue && onChangeValue({
            ...props,
            ...value,
            ...newProps
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        onClick: onClickValue,
        children: /*#__PURE__*/ _jsx("div", {
            className: readOnly ? "pointer-events-none" : "",
            children: /*#__PURE__*/ _jsx(SField, {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-2 gap-3 items-center",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    children: "Keyboard Type"
                                }),
                                /*#__PURE__*/ _jsx(SDropdownV3, {
                                    borderless: false,
                                    options: keyboardTypeOptions,
                                    value: keyboardTypeOptions.find((option)=>option.value === value?.keyboardType),
                                    onChange: (keyboardType)=>{
                                        setProps({
                                            keyboardType: keyboardType.value
                                        });
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-2 gap-3 items-center",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    children: "Placeholder"
                                }),
                                /*#__PURE__*/ _jsx(SInputV2, {
                                    value: value?.placeholder,
                                    placeholder: "Enter placeholder...",
                                    onChange: (e)=>setProps({
                                            placeholder: e.target.value
                                        })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
